







































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ModalWrapper from '@/wrappers/ModalWrapper.vue';
import Button from '@/components/Button.vue';
import MaskedInput from 'vue-masked-input'
import http from '@/methods/http.ts';
import moment from 'moment';

@Component({
    components: {
        ModalWrapper,
        Button,
        MaskedInput
    }
})
export default class WelcomeSpecialist extends Vue {
    @Prop(Boolean) opened: boolean;
}

